export default __webpack_public_path__ + "static/media/Letter X.806d8b0d.mov";